<template>
  <v-container>
    <v-layout row wrap class="mt-5">
      <v-flex xs12 sm6 offset-sm3>
        <v-card class="pa-4" d-none>
          <v-form ref="form" @submit.prevent="doRegister" lazy-validation>
            <v-container>
              <h1 class="primary--text">Partner Sign Up</h1>
              <p class="grey--text">Create a new Partner account on HUIREP</p>

              <app-alert
                class="mb-3"
                type="error"
                :outline="true"
                :message="error"
                @dismissed="error = false"
              />

              <v-layout row wrap class="mt-4">
                <v-flex xs12>
                  <h3 class="accent--text">1. Partner Information</h3>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    label="Partner Name"
                    type="text"
                    v-model="user.agency_name"
                    :rules="[rules.isRequired]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    label="Website"
                    type="text"
                    v-model="user.agency_more"
                    :rules="[rules.isRequired]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-select
                    label="Partner Type"
                    v-model="user.agency_tag"
                    :items="agencyTypeOptions"
                    :rules="[rules.isRequired]"
                    required
                  ></v-select>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="mt-4">
                <v-flex xs12>
                  <h3 class="accent--text">2. Partner Admin Details</h3>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Full Name"
                    type="text"
                    v-model="user.name"
                    :rules="[rules.isRequired]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    label="Email Address"
                    type="email"
                    v-model="user.email"
                    :rules="[rules.isEmail]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    label="Phone Number"
                    type="number"
                    v-model="user.phone"
                    :rules="[rules.isPhone]"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="mb-2">
                <v-flex xs12 md6>
                  <v-text-field
                    height="30"
                    label="Password"
                    type="password"
                    v-model="user.hash"
                    :rules="[rules.isRequired]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    height="30"
                    label="Confirm Password"
                    type="password"
                    v-model="user.c_hash"
                    :rules="[rules.isRequired, matchedPasswords]"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout class="align-center mt-4">
                <v-btn depressed color="accent" type="submit" :disabled="isLoading">
                  Register
                  <v-progress-circular
                    class="ml-3"
                    :indeterminate="true"
                    :size="18"
                    :width="2"
                    v-if="isLoading"
                  ></v-progress-circular>
                </v-btn>
                <v-spacer></v-spacer>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
    <MainFooter />
  </v-container>
</template>

<script>
import MainFooter from '@/components/Footer/MainFooter.vue'
import { setFormData } from '@/utils/http'
import rolesData from '@/data/roles'
import { agencyTypeOptions } from '@/data/options'

export default {
  name: 'Register',
  components: {
    MainFooter
  },
  data () {
    return {
      user: {
        agency_name: '',
        agency_status: 'active',
        agency_more: '',
        agency_tag: '',
        agency_country_id: this.$settings.country,
        email: '',
        phone: '',
        name: '',
        parent: 'agency',
        role: rolesData.agencyHead,
        status: 'inactive',
        hash: '',
        c_hash: ''
      },
      agencyTypeOptions: agencyTypeOptions,
      isLoading: false,
      error: false,
      rules: {
        isRequired: value => this.$validator.isRequired(value),
        isEmail: value => this.$validator.isEmail(value),
        isPhone: value => this.$validator.isPhone(value)
      }
    }
  },
  computed: {
    matchedPasswords () {
      return this.user.hash !== this.user.c_hash ? 'Passwords do not match' : true
    }
  },
  methods: {
    doRegister () {
      if (!this.$refs.form.validate()) return
      this.error = false
      this.isLoading = true
      const newUser = Object.assign({}, this.user)
      delete newUser.c_hash // delete confirm password prop
      
      const params = setFormData(newUser)
      this.$http.post('agency/signup', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            this.$router.push('/auth/login?newAgency=1')
          }
          else {
            this.error = response.message
          }
        })
        .finally(() => (this.isLoading = false))
    }
  }
}
</script>
